import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API_CONFIG } from "../../config/apiConfig"
import BannerSection from "../../components/AboutUs/BannerSection";
import whoWeAreBannerImg from "../../assets/images/banner4.webp";
import ValuesSection from "../../components/AboutUs/philosophy/ValueCard";

const AboutPhilosophy = () => {
  const [apiData, setApiData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // 2. Axios call (headers ke saath)
        const response = await axios.get(`${API_CONFIG.BASE_URL}/our-values`, {
          headers: API_CONFIG.HEADERS
        });
        const result = response.data;

        if (result.success) {
          setApiData(result.data);
          console.log("✅our value:", result.data);
        }
      } catch (error: any) {
        // Axios errors ko handle karna aasaan hai
        console.error("❌ Axios Error:", error.response?.data || error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  // --- MOVE THESE CHECKS ABOVE THE DESTRUCTURING ---
  if (loading) return <div className="py-20 text-center font-bold">Loading...</div>;
  if (!apiData) return <div className="py-20 text-center text-red-500">Failed to load data.</div>;

  const {
    title = "Our Philosophy", // Default title agar admin ne nahi dala
    description = "",
    values_list = [], // Sabse zaroori: Array ko empty rakhein taaki .map() na toote
    promise_title = "Our Promise",
    promise_image_url = "/fallback-image.jpg" // Local image as backup
  } = apiData || {};
  return (
    <main>
      <BannerSection
        title={apiData.title || "Our Values / Philosophy"}
        bannerImg={apiData.hero_bg_image_url || whoWeAreBannerImg}
        position="50% 30%"
      />

      {/* Passing all relevant data to the section */}
      <ValuesSection
        description={apiData.description}
        values={apiData.values_list}
        promiseTitle={apiData.promise_title}
        promiseDesc={apiData.promise_desc}
        promiseImage={apiData.promise_image_url}
      />
      <section className="bg-white pt-8 md:pt-10 pb-12 md:pb-16">
        <div className="max-w-7xl mx-auto px-4 md:px-10 lg:px-8 flex items-center justify-between gap-6 md:gap-8">
          <Link
            to="/about/leadership"
            className="inline-flex items-center gap-2 border-2 border-primary-red bg-transparent px-6 py-3 text-primary-red font-bold uppercase tracking-wide transition-colors hover:bg-primary-red hover:text-white"
          >
            <span aria-hidden="true">&lt;-</span>
            <span>Leadership</span>
          </Link>
          <Link
            to="/about/csr"
            className="inline-flex items-center gap-2 border-2 border-primary-red bg-transparent px-6 py-3 text-primary-red font-bold uppercase tracking-wide transition-colors hover:bg-primary-red hover:text-white"
          >
            <span>Corporate Social Responsibility</span>
            <span aria-hidden="true">-&gt;</span>
          </Link>
        </div>
      </section>
    </main>
  );
};

export default AboutPhilosophy;
